export function getStaticJson(key: string) {
  return fetch(`https://app.myhubble.money/ssr/${key}`, {}).then((response) =>
    response.json()
  );
}

export function getStaticProxyJson(key: string) {
  return fetch(`https://app.myhubble.money/static/proxy/${key}`, {}).then(
    (response) => response.json()
  );
}

export function getMarkdown(key: string) {
  return fetch(`https://renderer.myhubble.money/v3/api/static/${key}`, {}).then(
    (response) => response.json()
  );
}

export function getJson<T>(key: string) {
  return fetch(`https://renderer.myhubble.money/v3/api/static/${key}`, {}).then(
    (response) => response.json() as T
  );
}
